import { atom } from "recoil";
import { ILogin } from "../model/Users";

export const TokenAtomState = atom({
  key: 'atomToken',
  default: {} as unknown as ILogin
})